import AxiosClient from './clients/axios'

const resource = 'integrations/mobly/services/os'

const reprocessOrder = async (orderCod) => {
  const url = `${resource}/orders/${orderCod}`

  const response = await AxiosClient().get(url)

  return response.data
}

export {
  reprocessOrder
}
